import * as React from "react";
import { HeroSection, HowItWorks, Testimonials, FAQ, Footer, WhatsAppWidget, Header, StickyMinimizedForm } from "..";

export type VintageFunnelV1Props = {
  backgroundUrl?: string;
  bannerSrc?: string;
  videoUrl?: string;
  posterUrl?: string;
  youtubeUrl?: string;
  agentName?: string;
  agentAvatar?: string;
  ctaText?: string;
  showChat?: boolean;
  showPrimaryButtons?: boolean;
  className?: string;
};

const DEFAULTS = {
  backgroundUrl:
    "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?q=80&w=1600&auto=format&fit=crop",
  bannerSrc:
    "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1200&auto=format&fit=crop",
  // Safe, public defaults for preview environments
  videoUrl:
    "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
  posterUrl:
    "https://images.unsplash.com/photo-1520975867597-0f5f341a6b9f?q=80&w=1600&auto=format&fit=crop",
  youtubeUrl: "https://www.youtube.com/watch?v=wPaQDfiXN7M",
  agentAvatar:
    "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop",
  agentName: "Rebecca Molitor",
  ctaText: "Request Zoom",
};

export const VintageFunnelV1: React.FC<VintageFunnelV1Props> = ({
  backgroundUrl = DEFAULTS.backgroundUrl,
  bannerSrc = DEFAULTS.bannerSrc,
  videoUrl = DEFAULTS.videoUrl,
  posterUrl = DEFAULTS.posterUrl,
  youtubeUrl = DEFAULTS.youtubeUrl,
  agentAvatar = DEFAULTS.agentAvatar,
  agentName = DEFAULTS.agentName,
  ctaText = DEFAULTS.ctaText,
  showChat = true,
  showPrimaryButtons = false,
  className,
}) => {
  return (
    <div
      className={className}
      style={{
        backgroundImage: `url(${backgroundUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="min-h-screen bg-[#0f2340]/80">
        {/* Top header */}
        <div className="sticky top-0 z-40 bg-[#0f2340]/80 backdrop-blur border-b border-white/10">
          <div className="mx-auto max-w-6xl px-4 py-3 text-white">
            <Header />
          </div>
        </div>

        <div className="mx-auto max-w-6xl px-4 py-10 text-white" style={{ gap: 'var(--fw-section-gap, 3rem)' }}>
          <div className="space-y-12">
            <HeroSection
              backgroundUrl={backgroundUrl}
              videoUrl={videoUrl}
              posterUrl={posterUrl}
              youtubeUrl={youtubeUrl}
              agentAvatar={agentAvatar}
            />
          </div>
          {showPrimaryButtons ? null : null}
          <div className="space-y-12">
            <HowItWorks />
            <Testimonials />
            <FAQ />
          </div>
        </div>
        {showChat && <WhatsAppWidget />}
        <StickyMinimizedForm />
        <Footer />
      </div>
    </div>
  );
};

export default VintageFunnelV1;


